/** Deterministic PRNG (George Marsaglia's multiply-with-carry style) driving ez-tree's skeleton
 *  pass. Seeded so the same seed always reproduces the same tree. */
export default class RNG {
	m_w = 123456789;
	m_z = 987654321;
	mask = 0xffffffff;

	constructor(seed: number) {
		this.m_w = (123456789 + seed) & this.mask;
		this.m_z = (987654321 - seed) & this.mask;
	}

	/**
	 * Returns a random number between min and max
	 */
	random(max = 1, min = 0) {
		this.m_z = (36969 * (this.m_z & 65535) + (this.m_z >> 16)) & this.mask;
		this.m_w = (18000 * (this.m_w & 65535) + (this.m_w >> 16)) & this.mask;
		let result = ((this.m_z << 16) + (this.m_w & 65535)) >>> 0;
		result /= 4294967296;

		return (max - min) * result + min;
	}
}
